<template>
  <div class="DiscussionReportFilterBar">
    <div class="container-fluid">
      <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc margin-left-2Perc"> 
        <div class="col-md-1 col-lg-1 text-align-right">
            Sender
        </div>    
        <div class="col-md-3 col-lg-3 padding-left-0px">
          <!-- <div class="form-group"> -->
            <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"> -->
              <select class="form-control" v-model="selectedEmailObj">
                <option value='-1' disabled>Select e-mail address</option>
                <option v-for="emailObj in getSenderList" v-bind:key="emailObj" v-bind:value="emailObj">{{ emailObj }}</option>
              </select> 
            <!-- </div> -->
          <!-- </div> -->
        </div> 
        <div class="col-md-1 col-lg-1 text-align-right width-6Perc padding-left-right-0Px">
              Start Date
        </div>    
        <div class="col-md-2 col-lg-2">
              <date-picker v-model="startDate" :config="config"></date-picker>
        </div>
        <div class="col-md-1 col-lg-1 text-align-right width-6Perc padding-left-right-0Px">
              End Date
        </div>    
        <div class="col-md-2 col-lg-2 Padding-left-0px">
              <date-picker v-model="endDate" :config="config"></date-picker>
        </div>
        <div class="col-md-1 col-lg-1">
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, false)">Show</button>
        </div>
        <div class="col-md-1 col-lg-1">
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, true)">Export</button>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
       <div class="osahanloading"></div>
      </div>
      <loader></loader>      
    </div>
  </div>    
</template>

<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import { constants } from '@/utils/constants'
import { emailService } from '@/server-util/email-service'
import AlertBox from '@/components/AlertOverlay'
import moment from 'moment'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['showExport'],
  created: function () {
    this.setDefaultValues()
    this.getSenderEmailIdList()
  },
  data: function () {
    var startTS = moment().tz('America/New_York').format('MM/DD/YYYY')
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedEmailObj: -1,
      startDate: startTS,
      config: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        maxDate: ''
      },
      endDate: startTS
    }
  },
  methods: {
    setDefaultValues: function () {
      this.config.maxDate = new Date()
    },
    getSenderEmailIdList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        if (storeObj.state.senderEmailList.length === 0) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
        }
        emailService
          .getSenderEmailList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.senderEmailList = responseObj.data
              // this.showSpinner = false
              this.$store.state.isLoading = false
            } else {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined SENDER EMAIL ID LISTING OPERATION'
        )
      }
    },
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.selectedEmailObj !== -1) {
        if (this.startDate !== '' && this.startDate !== null) {
          if (this.endDate !== '' && this.endDate !== null) {
            // AK: Emit selected details obj
            var obj = {
              emailObj: this.selectedEmailObj,
              startDate: this.startDate,
              endDate: this.endDate
            }
            this.$emit('selectedObj', obj)
            if (isExportBtnClicked) {
              this.$emit('isExportBtnClicked', true)
              this.$emit('isViewBtnClicked', false)
            } else {
              this.$emit('isExportBtnClicked', false)
              this.$emit('isViewBtnClicked', true)
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg =
            'Please select a end date.'
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg =
            'Please select a start date.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a sender.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker,
    'loader': Loader
  },
  computed: {
    getSenderList: {
      get: function () {
        return this.$store.state.senderEmailList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      }
    },
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    }
  },
  watch: {
    selectedGroupObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again
      this.selectedCohortObj = -1
      this.getAssociatedCohortList()
    }
  },
  name: 'DiscussionReportFilterBar'
}
</script>

<style scoped>
.DiscussionReportFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
  /* margin-right: 0 auto !important; */
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.text-align-right {
  text-align: right;
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left:0px;
}
.width-6Perc{
  width:6%;
}
.margin-left-2Perc{
  margin-left:2%;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/send_grid/SendGridFilterBar.vue